module.exports = __webpack_public_path__ + "img/b7.e536ba4d.png";